import { Button } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import OrderingTypeModal from '../../components/modals/OrderingTypeModal';
import UnderConstructionProgress from '../../components/theme/UnderContstructionProgress';
import Typography from '../../components/typography/Typography';
import { useCompany } from '../../hooks/useCompany';
import { CouponInterface } from '../../interfaces/Coupons';
import { CouponService } from '../../services/coupons/CouponService';
import {
  addCouponObject,
  fetchGroupRequirements,
  orderingType,
  resetCart,
  setOrderingType,
} from '../../state/shop/shopSlice';
import { RootState } from '../../state/store';

interface OrderingTypeGuardProps {
  children: React.ReactNode;
}

const OrderingTypeGuard: FC<OrderingTypeGuardProps> = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [couponValue, setCouponValue] = useState<CouponInterface>();
  const { companyId } = useCompany();

  const orderingType = useSelector(
    (state: RootState) => state.cart.orderingType
  );

  const dispatch = useDispatch();

  const handleSetOrderingType = (type: orderingType) => {
    dispatch(resetCart());
    dispatch(setOrderingType(type));
    if (type === 'cyod' && couponValue) {
      dispatch(fetchGroupRequirements(companyId));
      dispatch(addCouponObject(couponValue));
    }
  };

  const changeOrderingType = () => {
    dispatch(setOrderingType(''));
  };

  const couponService = new CouponService();
  useEffect(() => {
    const fetchCouponIfNeeded = async () => {
      setLoading(true);
      try {
        const couponValue = await couponService.getCoupon(companyId);
        dispatch(addCouponObject(couponValue));
        setCouponValue(couponValue);
      } catch (err) {
        console.error('Error fetching coupon:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchCouponIfNeeded();
  }, []);

  if (process.env.NODE_ENV != 'production') {
    return (
      <div className="mt-5">
        <UnderConstructionProgress
          info="Het Choose Your Own Device-gedeelte van ons portaal is tijdelijk
          opnieuw in ontwikkeling genomen. Door enkele bugs werkt dit
          onderdeel momenteel niet optimaal. We werken aan een oplossing
          en houden je op de hoogte zodra het weer volledig beschikbaar is."
          title="CYOD"
          percentage={20}
          phase="analysefase"
        />
      </div>
    );
  }

  return (
    <>
      {children}

      {!orderingType && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <OrderingTypeModal
            handleOnclick={handleSetOrderingType}
            coupon={couponValue?.cou_bedrag}
          />
        </div>
      )}
      {orderingType && (
        <>
          <Button
            className="fixed bottom-4 right-4"
            onClick={() => changeOrderingType()}
          >
            <Typography tag="span" type="label">
              Wijzig besteltype
            </Typography>{' '}
            : {orderingType}
          </Button>
        </>
      )}
    </>
  );
};

export default OrderingTypeGuard;
